module.exports = require("util");


//////////////////
// WEBPACK FOOTER
// external "util"
// module id = 48
// module chunks = 0